import { useHistory, useLocation } from "react-router-dom";
import Favicon from 'react-favicon';

import AppHeader from '../App/AppHeader/directvgo';

import { getImagePath } from '../../utils';
import { BsArrowLeftShort } from 'react-icons/bs';
import { useQuery } from "../../utils/hooks/useQuery";
import { useMediaQuery } from '@material-ui/core';

export const DefaultLayout = ({ children, client, faviconURL, bootstrap, intl }) => {
    const logoImg = getImagePath('logo.png', client);
    const query = useQuery()

    const Header = AppHeader;

    const history = useHistory()
    const location = useLocation()

    const mobile = useMediaQuery('(max-width: 420px)')
    const redirect = () => {
        const cloudpayConfig = window.AppENV.cloudpay;
        window.location.href = `${cloudpayConfig.baseURL}/redirect/goBackToReturnUrl${window.location.search}&jwt=${localStorage.getItem('jwt')}`;
      };

    const handleGoBack = (e) => {
        e.preventDefault();
        const returnUrl = new URL(query.get('return_url'));
        const subscriptionPathList = ['subscribe', 'subscriptions', 'plans'];
    
        const myaccount = location.pathname.includes('myaccount');
        const changePlan = location.pathname.includes('change-plan');
        const addOnPlus = location.pathname.includes('addon-plus');
        const shouldRedirectSubscription = location.pathname.split('/').slice(2).every(path => subscriptionPathList.includes(path));
 
        if (((myaccount && !changePlan && !addOnPlus) || (!myaccount && !changePlan && !addOnPlus && shouldRedirectSubscription)) && returnUrl) {
          return redirect();
        }
        history.goBack();
    }

    return (
        <div className="App Cloudpay">
            <Favicon url={faviconURL} />

            <>
                <Header
                    history={history}
                    image={{ alt: 'Logo', position: 'left', src: logoImg }}
                    bootstrap={bootstrap}
                    redirect={redirect}
                />

                <main className="container">
                    <div className="arrow_container">
                    <a onClick={handleGoBack} className="go-back" href="#">
                        <BsArrowLeftShort color="#FFFFFF" size={mobile ? 50 : 70} />
                    </a>
                    </div>
                    {children}
                </main>

                {/* <Footer /> from ../../containers/Footer (injectIntl + terms URL) */}
            </>
        </div>
    )
}